import {Button, Icon} from "~/components";

function PostOfficeAction({item, setItemEdit, openModal, can}) {

	const handleButtonClick = {
		edit: () => {
			setItemEdit(item);
			openModal('addEdit');
		},
		delete: () => {
			setItemEdit(item);
			openModal('delete');
		},
	}

	return (
		<div className="table-action d-flex">
			{can.edit && <Button background blue onClick={handleButtonClick.edit}>{Icon.edit}</Button>}
			{can.delete && <Button background red onClick={handleButtonClick.delete}>{Icon.delete}</Button>}
		</div>
	)
}

export default PostOfficeAction;